import Ajax from "@/api/ajax";
export default{
    //返利记录
    receiptGoods(params) {
        return Ajax.post("/Home/receiptGoods", params);
    },
    

}